import { parseMemberInfo, RETAIL_MODE_MEMBER_INFO_KEY } from "./retailPricingUtils";

export function normalizeProfileEmail(email) {
	return typeof email === "string" ? email.trim().toLowerCase() : "";
}

export function buildOrganizationMemberInfoPayload(memberInfoRaw, updates = {}) {
	const memberInfo = parseMemberInfo(memberInfoRaw);
	["company", "projectGroup"].forEach((field) => {
		if (!Object.prototype.hasOwnProperty.call(updates, field)) {
			return;
		}
		const value = typeof updates[field] === "string" ? updates[field].trim() : "";
		if (value) {
			memberInfo[field] = value;
		} else {
			delete memberInfo[field];
		}
	});

	if (Object.prototype.hasOwnProperty.call(updates, RETAIL_MODE_MEMBER_INFO_KEY)) {
		if (updates[RETAIL_MODE_MEMBER_INFO_KEY] === true) {
			memberInfo[RETAIL_MODE_MEMBER_INFO_KEY] = true;
		} else {
			delete memberInfo[RETAIL_MODE_MEMBER_INFO_KEY];
		}
	}

	return memberInfo;
}

export function buildUserProfileCognitoPayload({
	email,
	emailChatNotify,
	profilePicture
} = {}) {
	return {
		email: normalizeProfileEmail(email),
		emailChatNotify: emailChatNotify ? "true" : "false",
		profilePicture: typeof profilePicture === "string" ? profilePicture : ""
	};
}

export function buildOrganizationMemberProfilePayload({
	memberId,
	displayName,
	timeZone,
	profilePicture
} = {}) {
	return {
		id: memberId,
		displayName,
		timeZone,
		userProfileImage: profilePicture !== "" ? profilePicture : "none"
	};
}

export function getUserProfileSaveErrorMessage(err) {
	return (err && err.response && err.response.body && (
		err.response.body.message
		|| (err.response.body.err && err.response.body.err.message)
		|| err.response.body.error
	)) || (err && err.message) || "There was an error saving your user profile.";
}

export function getUserProfileAlgoliaSyncWarning(response) {
	const result = response && response.body ? response.body : response;
	const algoliaSync = result && result.algoliaSync;
	if (!algoliaSync || algoliaSync.success !== false) {
		return null;
	}

	return algoliaSync.warning
		|| "Profile saved, but existing search records could not be refreshed. New records will use the updated profile.";
}

export function isSsoManagedEmailOrganization(organization) {
	if (!organization) {
		return false;
	}

	const enterprise = organization.enterprise === true || organization.enterprise === 1 || organization.enterprise === "1";
	const tokenIssuer = typeof organization.enterprise_tokenIssuer === "string" ? organization.enterprise_tokenIssuer.trim() : "";
	return enterprise && tokenIssuer !== "";
}

export function hasSsoManagedEmailOrganization(organizations) {
	return Array.isArray(organizations) && organizations.some(isSsoManagedEmailOrganization);
}
